import type DebugSettings from './DebugSettings';

import DataTableColorizationMode from '@/features/data-table/data-table-colorization/models/DataTableColorizationMode';

export default function getInitialDebugSettings(): DebugSettings {
  return {
    colorizationMode: DataTableColorizationMode.COLORED_ROWS,
    isEnableLogging: false,
    isProtectionOpenBetaDisabled: false,
    isShowMonitorForDevelopersInMenu: false,
    isSyncSortingAndFiltersWithRouter: true,
    isWithVerticalBorders: false,
  };
}
